<ng-container *ngIf="days$ | async as days; else loading">

<ion-toolbar class="ion-no-padding" mode="ios">
  <ion-button (click)="slidesElem.slidePrev()" fill="clear" slot="start">
    <ion-icon slot="icon-only" class="arrow-left" ></ion-icon>
  </ion-button>
  <ion-title class="swiper-header">{{ getMonthAndYear(selectedDay, translateService.currentLang) || '2023' }}</ion-title>
  <ion-button (click)="slidesElem.slideNext()" fill="clear" slot="end">
    <ion-icon slot="icon-only" class="arrow-right"></ion-icon>
  </ion-button>
</ion-toolbar>

<ion-slides #slidesElem pager="true" pager="false" (ionSlidesDidLoad)="goToInitialSlide()" [options]="slideOpts" class="swiper">

  <ng-container *ngFor="let day of days.items; let i = index">
  <ion-slide class="slide clickable" *ngIf="real?.provider?.id != 335 || day.isOpen">
    <div class="day" [ngClass]="{ 'day--closed': (!day.hasSlots && !day.isOpen) || (!day.hasSlots && day.isOpen), 'day--selected': (selectedDay===day.date && ('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug)), 'day--selected-secondary': (selectedDay===day.date && ('restavracija-strelec' == real?.slug || 'jaz-by-me' == real?.slug)) }" (click)="selectDay(day)">
      <div class="day__day-of-week">{{ getDayOfWeek( day.date,translateService.currentLang ) }}</div>
      <div class="day__day-of-month">{{ getDayOfMonth(day.date,translateService.currentLang ) }}</div>
      <div class="day__month">{{ getMonth(day.date,translateService.currentLang) }}</div>
      <div class="day__price">
        <span *ngIf="!day.hasSlots && day.isOpen">{{ 'PICK_SLOT.TAKEN' | translate }}</span>
        <span *ngIf="!day.hasSlots && !day.isOpen && day.workingUntil">{{ 'PICK_SLOT.CLOSED_ALREADY' | translate }}</span>
        
        <span *ngIf="!day.hasSlots && !day.isOpen && !day.workingUntil && ( real?.provider?.id != 437 || i > 0 )">{{ 'PICK_SLOT.CLOSED' | translate }}</span>

        <span *ngIf="!day.hasSlots && !day.isOpen && !day.workingUntil && ( real?.provider?.id == 437 && i === 0 )">{{ 'PICK_SLOT.NO_BOOKINGS' | translate }}</span>


        <span *ngIf="day.hasSlots">
          {{ 'PICK_SLOT.AVAILABLE' | translate }}
          <!--span class="price-range" *ngIf="day.priceRange.min !== day.priceRange.max">od</span>
          {{ day.priceRange.min | number:'1.2-2' }}€-->
        </span>
      </div>
      <div class="day__event" *ngIf="getEventText( day.events, translateService.currentLang )">{{ getEventText( day.events, translateService.currentLang) }}</div>
    </div>
  </ion-slide>
  </ng-container>
</ion-slides>

</ng-container>

<ng-template #loading>
  <ion-grid> 
    <ion-row style="height:100px" class="ion-align-items-center"><ion-col class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></ion-col></ion-row>
  </ion-grid>
</ng-template>